import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionCreatePlanAssignmentRevisionPlanPayload } from 'api/actions/revision-create-plan-assignment-revision-plan/revision-create-plan-assignment-revision-plan-payload';
import { RevisionCreatePlanAssignmentRevisionPlanPathParameters } from 'api/actions/revision-create-plan-assignment-revision-plan/revision-create-plan-assignment-revision-plan-path-parameters';
import { RevisionCreatePlanAssignmentRevisionPlanResponse } from 'api/actions/revision-create-plan-assignment-revision-plan/revision-create-plan-assignment-revision-plan-response';

type RevisionCreatePlanAssignmentRevisionPlanQueryParameters = Record<string, any>;

/**
 * The path of the RevisionCreatePlanAssignmentRevisionPlan action.
 */
export const revisionCreatePlanAssignmentRevisionPlanActionPath = new SweetPath<
  keyof RevisionCreatePlanAssignmentRevisionPlanPathParameters
>('/api/revision/plan-assignments/{revisionId}/device/{deviceId}/revision-plan', { path: '{param}' });

/**
 * Creates a contextualized RevisionCreatePlanAssignmentRevisionPlan actions.
 */
export default function createRevisionCreatePlanAssignmentRevisionPlanAction(axios: AxiosInstance) {
  return function revisionCreatePlanAssignmentRevisionPlanAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionCreatePlanAssignmentRevisionPlanPathParameters;
    query?: RevisionCreatePlanAssignmentRevisionPlanQueryParameters;
    payload: RevisionCreatePlanAssignmentRevisionPlanPayload;
  }) {
    const path = revisionCreatePlanAssignmentRevisionPlanActionPath.insert(parameters);

    return axios.request<
      RevisionCreatePlanAssignmentRevisionPlanResponse,
      RevisionCreatePlanAssignmentRevisionPlanResponse
    >({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
